import { render, staticRenderFns } from "./IndividualAttendedCourses.vue?vue&type=template&id=89e80c8c&scoped=true&"
import script from "./IndividualAttendedCourses.vue?vue&type=script&lang=js&"
export * from "./IndividualAttendedCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e80c8c",
  null
  
)

export default component.exports